import { render, staticRenderFns } from "./vBrandList.vue?vue&type=template&id=6581e9fe&scoped=true&"
import script from "./vBrandList.vue?vue&type=script&lang=js&"
export * from "./vBrandList.vue?vue&type=script&lang=js&"
import style0 from "./vBrandList.vue?vue&type=style&index=0&id=6581e9fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6581e9fe",
  null
  
)

export default component.exports